export default __webpack_public_path__ + "static/media/blog_2.7f76d605.png";